import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartyTypeAddUpdateComponent } from './party-type-add-update/party-type-add-update.component';
import { PartyTypeListComponent } from './party-type-list/party-type-list.component';
import { PartyAddUpdateComponent } from '../party/party-add-update/party-add-update.component';
import { CoreModule } from '../../core/core.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NeoTableLibModule } from 'neo-table-lib';
import { NgSelectModule } from '@ng-select/ng-select';

const routes: Routes = [
  { 
    path: 'partyType',
    component: PartyTypeListComponent,
  },
  {
    path: 'partyTypeList',
    component: PartyTypeListComponent,
  },
  {
    path: 'partyTypeAddUpdate',
    component: PartyTypeAddUpdateComponent,
  },
  {
    path: 'partyTypeAddUpdate/:id',
    component: PartyTypeAddUpdateComponent,
  },
];
@NgModule({
  declarations: [PartyTypeAddUpdateComponent, PartyTypeListComponent],
  imports: [
    CommonModule,
    CoreModule,
    NgSelectModule,
    Ng2SmartTableModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NeoTableLibModule,
  ],
  exports: [
  PartyTypeListComponent
],
  entryComponents: [
    PartyTypeListComponent
]
})
export class PartyTypeModule {}
